import { FONT } from "../../value/staticValues";

import { ReactComponent as StatusStableImg} from "../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../img/ico-status-block.svg";

import { ReactComponent as AlertImg } from "../../img/ico-status-alert.svg";
import { ReactComponent as ErrorImg } from "../../img/ico-status-error.svg";


import { ListActionMenu, ListFilter, ListTableHeader } from "../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../value/type";

import i18n from "../../lang/base";
import { getAuditLogTypeString } from "./AuditLogUtils";
import AuditLogDetail from "./AuditLogDetail";
import { parseLocaleDatetime } from "common/util";



export interface AuditLogSystemData {
    category: string;
    create_ts: string;
    update_ts: string;
    message: string;
    source: string;
    sub_category: string;
    subject: string;
    audit_log_id: string;
    audit_log_severity_code: string;
    audit_log_status_code: string;
}


export const tableHeaders:ListTableHeader[] = [
    {
        Header: 'Levels',
        accessor: "audit_log_severity_code",
        disableSortBy: true,
        style: {
            width: "100px",
            paddingLeft: "20px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                marginLeft: 15,
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value === "CRT" ? "#e6735c" : value === "WARN" ? "#8c8c8c" : "#3a8344",
            }}>
                {
                    value === 'CRT' ? <ErrorImg style={className.statusImg} /> : value === 'WARN' ? <AlertImg style={className.statusImg}/> : <StatusStableImg style={className.statusImg}/>
                }
                {
                    value === 'CRT' ? "Critical" : value === 'WARN' ? "Warning" : value === 'NRM' ? "Normal" : value === 'INFO' ? "Info" : "Unknown"
                }
            </div>
        )
    },
    {
        Header: 'Source',
        accessor: "source",
        disableSortBy: false,
        style: {
            width: "150px",
            paddingLeft: "20px"
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, paddingLeft: 20}}>{value}</div>)
    },
    {
        Header: i18n.t("LOG_MESSAGE_TEXT"),
        accessor: 'message',
        disableSortBy: true,
        style: {
            width: "380px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer}}>{value}</div>
        )
    },
    {
        Header: 'Category',
        accessor: "category",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{value}</div>
        )
    },
    {
        Header: 'Sub Category',
        accessor: "sub_category",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.purpleText}}>{value}</div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : "-"}
            </div>
        )
    },
];



export const auditLogDetailModalContent = {
    title: i18n.t("LOG_DETAIL_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("CONFIRM_TEXT")
        },
    ],
    innerComponent: <AuditLogDetail />,
}

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },
}